import { dom } from '@omegagrid/core';
import { FormContainer } from "@omegagrid/form";
import rp, { AppComponent, Application, ParsedComponentId, GridEditor, SyncGridEditorAdapter } from '@reporting/rp-app-host';
import { TableDefinition} from "@reporting/rp-types/mdm";
import { Sidebar } from './components';
import { TableDefFormAdapter, MdmColumnsDefGridEditorAdapter, MdmValuesGridEditorAdapter, SqlValuesGridEditorAdapter, SqlColumnsDefGridEditorAdapter, 
	MdmSyncEditorAdapter } from './adapters';
import { TableType, TableTypes } from './types';
import { GridEditEvent } from '@omegagrid/grid';

const createMainSidebar = (app: Application, componentId: ParsedComponentId) => {
	const sidebar = dom.createElement<Sidebar>('rp-mdm-sidebar');
	return sidebar;
}

const createValuesGridEditor = async (app: Application, componentId: ParsedComponentId) => {
	const type = componentId.ids[1] as TableType;
	const idTable = parseInt(componentId.ids[2]);
	const component = dom.createElement<GridEditor>('rp-editor-grid');
	component.adapter = type == TableTypes.MDM
		? new MdmValuesGridEditorAdapter(idTable)
		: type == TableTypes.SQL
			? new SqlValuesGridEditorAdapter(idTable)
			: null; 
	return component;
}

const createTableDefForm = async (app: Application, componentId: ParsedComponentId) => {
	const tableType = componentId.ids[1] as TableType;
	if (!tableType) throw new Error('Table type is not defined');
	const tableId = componentId.ids[2] ? parseInt(componentId.ids[2]) : null;
	let table: TableDefinition = { type: tableType, id_md: tableId };
	if (tableId) {
		const existingTable = await rp.ms('mdm').get<TableDefinition>(`tableDefinitions/${tableId}`);
		if (existingTable) table = existingTable;
	}
	const component = dom.createElement<FormContainer>('og-form-container');
	component.adapter = new TableDefFormAdapter(table);
	component.addEventListener('form.save', async () => {
		(rp.host.components.get('mdm') as Sidebar)?.refresh();
		try {
			(rp.host.components.get(`mdm-values-${tableType}-${tableId}`) as GridEditor)?.refresh();
		} catch {}
	});
	return component as unknown as AppComponent;
}

const createColumnsDefGridEditor = async (app: Application, componentId: ParsedComponentId) => {
	const table = await rp.ms('mdm').get<TableDefinition>(`tableDefinitions/${parseInt(componentId.ids[1])}`);
	if (!table) throw new Error('Table definition not found');
	const component = dom.createElement<GridEditor>('rp-editor-grid');
	if (table.type == TableTypes.MDM) {
		component.adapter = new MdmColumnsDefGridEditorAdapter(table);
		component.addEventListener('grid.edit', async (e: GridEditEvent) => {
			if (!e.cells) return;
			const listRows = e.cells.filter(c => c.column.data === 'property_type').map(c => c.row);
			if (listRows.length === 0) return;
			(component.adapter as MdmColumnsDefGridEditorAdapter).reloadDialAdapters(listRows);
		});
	} else {
		component.adapter = new SqlColumnsDefGridEditorAdapter(table);
	}
		
	return component;
}

const createSyncEditor = async (app: Application, componentId: ParsedComponentId) => {
	const component = dom.createElement<GridEditor>('rp-editor-grid');
	component.adapter = new SyncGridEditorAdapter(new MdmSyncEditorAdapter());
	return component;
}

export const componentFactories = new Map<string, (app: Application, componentId: ParsedComponentId) => AppComponent|Promise<AppComponent>>([
	['mdm', createMainSidebar],
	['values', createValuesGridEditor],
	['tableDefForm', createTableDefForm],
	['columnsDef', createColumnsDefGridEditor],
	['sync', createSyncEditor],
]);

